export { cn } from "@dreamhub/designsystem";

export const getHexColor = (colorVar: string) => {
  // Remove 'var(' and ')' from the string
  const cssVarName = colorVar.slice(4, -1);

  // Create a temporary element
  const temp = document.createElement("div");
  // Set the color property using the CSS variable
  temp.style.color = `var(${cssVarName})`;
  // Append it to the body
  document.body.appendChild(temp);

  // Get the computed color
  const computedColor = window.getComputedStyle(temp).color;

  // Remove the temporary element
  document.body.removeChild(temp);

  // Convert rgb to hex
  const rgb = computedColor.match(/\d+/g);
  return rgb
    ? "#" + rgb.map((x) => parseInt(x).toString(16).padStart(2, "0")).join("")
    : colorVar;
};
